import React, {useState, useEffect} from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import './Header.scss';
import { useNavigate  } from 'react-router-dom';

//Imagens
import logo from './img/logo-light-new.svg'
import logolight from './img/logo-dark-new.svg'
import imgZero from "../Header/img/imgZero.png"
import imgBlindados from "../Header/img/imgBlindagem.png";
import imgSeminovos from "../Header/img/imgSeminovos.png";

// Components
import Menu from "../../components/Home/Menu";

function Header({type}) {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);   
    const [menuOpenMobile, setMenuOpenMobile] = useState(false); 


    const toggleMenuMobile = () => {
        setMenuOpenMobile(!menuOpenMobile);
    };

    const toggleMenu = () => {
        setMenuOpen(prevState => !prevState);
    };

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    useEffect(() => {
        scrollToTop();
    }, []);
    // onClick={toggleMenu}

    return (
        <>
            <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
            <header className={type}>
                <Container>
                    <Row>
                        <Col>
                            <nav className="navbar navbar-expand-lg navbar-light ">
                                <Link className="navbar-brand" to="/"><img className="logo" src={(type == "light") ? logo : logolight} /></Link>
                                <div className="btnsMobile">
                                    <a onClick={() => navigate(`/busca`)}  className=""><Icon icon="eva:search-outline" /></a>
                                    <a onClick={toggleMenuMobile} className=""><Icon icon="heroicons-outline:menu-alt-2" /></a>
                                </div>
                                <div className={`collapse navbar-collapse justify-content-center ${menuOpenMobile ? 'show' : ''}`} id="navbarMenu">
                                    {menuOpenMobile && (
                                        <a  className="closeMenu" onClick={toggleMenuMobile}><Icon icon="iconamoon:close-duotone" /></a>
                                    )}
                                    <ul className="navbar-nav mr-auto">
                                        <li><Link to="/busca">Veículos</Link></li>
                                        <li><Link to="/motos">Motos</Link></li>
                                        <li><Link to="/blindagem">Blindagem</Link></li>
                                        <li><Link to="/estetica">Estética</Link></li>
                                        <li><Link to="/funilaria">Funilaria</Link></li>
                                        <li><Link to="/sobre">Sobre</Link></li>
                                        <li className='onMobile'><Link to="/faleconosco">Contato</Link></li>
                                        <li className='onMobile'><Link to="/busca"><Icon className="icons" icon="mingcute:search-line" /></Link> </li>
                                    </ul>
                                  {/*  <ul className='listVeiculos'>
                                        <h3>Veículos</h3>
                                        <li>
                                            <div onClick={() => {
                                                    navigate(`/busca/todos/todos`);
                                                    if (menuOpenMobile) {
                                                        toggleMenuMobile();
                                                    }
                                                }} className='itemNossosVeiculos'>
                                                <div className="foto">
                                                    <img src={imgZero} />
                                                </div>
                                                <div className="desc">
                                                    <div className='servico'>
                                                        <div className='textServico'>
                                                            <h6>nossos serviços</h6>
                                                            <h5>veículos zero km</h5>
                                                        </div>
                                                    </div>
                                                    <Link className="btn btn-plus"><Icon className="icons" icon="fe:plus" /></Link>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div onClick={() => {
                                                    navigate(`/busca/blindados/todos`);
                                                    if (menuOpenMobile) {
                                                        toggleMenuMobile();
                                                    }
                                                }} className='itemNossosVeiculos'>
                                                <div className="foto">
                                                    <img src={imgBlindados} />
                                                </div>
                                                <div className="desc">
                                                    <div className='servico'>
                                                        <div className='textServico'>
                                                            <h6>nossos serviços</h6>
                                                            <h5>veículos blindados</h5>
                                                        </div>
                                                    </div>
                                                    <Link className="btn btn-plus"><Icon className="icons" icon="fe:plus" /></Link>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div onClick={() => {
                                                    navigate(`/busca/todos/semi-novo`);
                                                    if (menuOpenMobile) {
                                                        toggleMenuMobile();
                                                    }
                                                }} className='itemNossosVeiculos'>
                                                <div className="foto">
                                                    <img src={imgSeminovos} />
                                                </div>
                                                <div className="desc">
                                                    <div className='servico'>
                                                        <div className='textServico'>
                                                            <h6>nossos serviços</h6>
                                                            <h5>veículos seminovos</h5>
                                                        </div>
                                                    </div>
                                                    <Link className="btn btn-plus"><Icon className="icons" icon="fe:plus" /></Link>
                                                </div>
                                            </div>
                                        </li>
                                    </ul> */}
                                </div>
                                <div className="btnFalecConosco">
                                    <Link to="/busca" className='btnBusca'>buscar <Icon className="icons" icon="mingcute:search-line" /></Link>
                                    <Link to="/faleconosco" className={`btn btn-${type == "light" ? 'primary' : 'quaternary'}`}>Entre em contato</Link>
                                </div>
                            </nav>
                        </Col>
                    </Row>
                </Container>
            </header>
        </>
    );
}

export default Header;
